module.exports = "/packs/images/diabetes_form~5748d265b3e0a0eace8f4f9d41da2029.png";